import './boxContact.css'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneFlip, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

function BoxContact() {
  return (
    <div className='boxcontact'>
      <div className="row">
        <div className="col-12 mt-3">
          <div className="rn">
            <div className="rn-icon">
              <FontAwesomeIcon icon={faPhoneFlip} />
            </div>
            <div className='textbox'>
              <p className='p1'>إتصل الأن</p>
              <a href="tel:0568300288">0568300288</a>
            </div>
          </div>
        </div>
        <div className="col-12 mt-3">
          <div className="rn">
            <div className="rn-icon">
              <FontAwesomeIcon icon={faEnvelope} />
            </div>
            <div className='textbox'>
              <p className='p1'>تواصل معنا</p>
              <a href="mailto:techweb.sa.info@gmail.com">techweb.sa.info@gmail.com
              </a>
            </div>
          </div>
        </div>
        <div className="col-12 mt-3">
          <div className="rn">
            <div className="rn-icon">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
            </div>
            <div className='textbox'>
              <p className='p1'>أين نتواجد؟</p>
              <a href="https://maps.app.goo.gl/hwU37737ad8Rc9fMA" rel="noopener" target='_blank'>عسير - أبها</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BoxContact
